
import { urlChunks } from '../constants/configs/endpoints';
import { ALL_USER_ROLES } from '../constants/roles/userRoleTypes';


export const useInboxId = (data) => {

    let part;
    let inboxId;

    const {
        householdId,
        impersonation,
        impersonationDetails,
        isInImpersonation,
        role,
        userId
    } = data;

    const {
        HOUSEHOLD_ID,
        USER_ID
    } = urlChunks;

    const { INDIVIDUAL, INDIVIDUAL_LITE } = ALL_USER_ROLES;

    switch (impersonation) {
        case true:
            switch (impersonationDetails.role) {
                case INDIVIDUAL:
                case INDIVIDUAL_LITE:
                    part = HOUSEHOLD_ID;
                    inboxId = impersonationDetails.householdId;
                    break;
            
                default:
                    part = USER_ID;
                    inboxId = impersonationDetails.userId;
                    break;
            }
            break;

        case false:
            switch (role) {
                case INDIVIDUAL:
                case INDIVIDUAL_LITE:
                    part = HOUSEHOLD_ID;
                    inboxId = householdId;
                    break;

                default:
                    part = USER_ID;
                    inboxId = userId;
                    break;
            }
            break;
    }

    return {
        part: isInImpersonation ? HOUSEHOLD_ID : part,
        inboxId: isInImpersonation ? householdId : inboxId
    };
};